// Load project-specific SCAD config overrides
import "~/config/componentMap";

export default defineNuxtPlugin(() => {
  // Config is loaded via side-effect import above
});
